import { paths } from "helpers/paths";
import React, { useEffect } from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import List from "./list";
import Show from "./show";

interface WaybillsProps extends RouteComponentProps {
    clearParams: (key: string) => void;
}

const Waybills = ({ location, clearParams }: WaybillsProps) => {
    useEffect(() => () => clearParams("waybills"), [clearParams]);

    return (
        <Switch location={location}>
            <Route exact path={paths.waybills} component={List} />
            <Route path={paths.waybillsShow(":id")} component={Show} />
        </Switch>
    );
};

export default Waybills;
